import React from "react";
import Label from "components/general/Label";
import useViewport from "components/general/useViewPort";
import Horse from "components/presentation/Horse";
import Competitor from "components/presentation/Competitor";


const PreviousCurrent = (props) => {
    const { current, previous } = props;
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const xlPrevious = <ResultBoxXl result={previous}/>;

    const xsPrevious = <ResultBoxXs result={previous}/>;

    const xlCurrent = <ResultBoxXl result={current}  current={true}/>;

    const xsCurrent = <ResultBoxXs result={current} current={true}/>;
   
    return <>
        { !previous ? <></> : isMobile ? xsPrevious : xlPrevious }
        { !current  ? <></> : isMobile ? xsCurrent  : xlCurrent  }
    </>

    
}


const ResultBoxXl = (props) => {
    const { result, current } = props;
    
    let rowHeader
    if (current) {
        rowHeader = (
            <tr>
                <td className="text-end fw-bold w-10 mirs-break-line"><Label data='LabelStartOrder' /></td>
                <td className="text-start fw-bold w-2   5"><Label data='HeaderRider' /></td>
                <td className="text-start fw-bold w-35"><Label data='HeaderHorse' /></td>
                <td className="text-start fw-bold w-30"><Label data='HeaderPenalties' /></td>
            </tr>
        );
    } else {
            rowHeader = (   
            <tr>
                <td className="text-end fw-bold w-10 mirs-break-line"><Label data='LabelStartOrder' /></td>
                <td className="text-start fw-bold w-25"><Label data='HeaderRider' /></td>
                <td className="text-start fw-bold w-25"><Label data='HeaderHorse' /></td>
                <td className="text-center fw-bold w-10"><Label data='HeaderTime' /></td>
                <td className="text-start fw-bold w-10"><Label data='HeaderPenalties' /></td>
                <td className="text-end fw-bold w-10 mirs-break-line"><Label data='HeaderRidingPoints' /></td>
                <td className="text-center fw-bold w-10"><Label data='HeaderRank' /></td>
            </tr>
        );

    }

    let rowResult
    if (current) {
        rowResult = (
            <tr>
                <td className="text-end">{result?.startOrder}</td>
                <td className="text-start"><Competitor {...result?.participant} alwaysNoc={true} hidePicture={true}/></td>
                <td className="text-start"><Horse {...result?.horse}/></td>
                <td className="text-start"><Penalties result={result} /></td>
            </tr>
        );
    } else {
        rowResult = (
            <tr>
                <td className="text-end">{result?.startOrder}</td>
                <td className="text-start"><Competitor {...result?.participant} alwaysNoc={true} hidePicture={true}/></td>
                <td className="text-start"><Horse {...result?.horse}/></td>
                <td className="text-center"><Time result={result} /></td>
                <td className="text-start"><Penalties result={result} /></td>
                <td className="text-end fw-bold">{result?.resultData}</td>
                <td className="text-center fw-bold"><Rank result={result} /></td>
            </tr>
        );

    }


    return (
        <table className="table table-sm table-bordered border">
            <caption><Label data={current ? 'HeaderCurrentComp': 'HeaderPreviousComp'}/></caption>
            <thead>
                {rowHeader}
            </thead>
            <tbody>
                {rowResult}
            </tbody>
        </table>
    );

}

const ResultBoxXs = (props) => {
    const {result, current} = props;

    let rowHeader
    if (current) {
        rowHeader = (
            <tr>
                <td className="text-start fw-bold w-100"><Label data='HeaderCurrentComp' /></td>
            </tr>
        );
    } else {
            rowHeader = (   
            <tr>
                <td className="text-start fw-bold w-70"><Label data='HeaderPreviousComp' /></td>
                <td className="text-end fw-bold w-15 mirs-break-line" ><Label data="HeaderRidingPoints" /></td>
                <td className="text-end fw-bold w-15"><Label data="HeaderRank" /></td>
            </tr>
        );

    }

    let rowResult
    if (current) {
        rowResult = (
            <tr>
                <td className="text-start"><Competitor {...result?.participant} alwaysNoc={true} hidePicture={true}/> <Horse {...result?.horse}/></td>
            </tr>
        );
    } else {
        rowResult = (
            <>
                <tr>
                    <td className="text-start"><Competitor {...result?.participant} alwaysNoc={true} hidePicture={true}/> <Horse {...result?.horse}/></td>
                    <td className="text-end fw-bold ">{result?.resultData}</td>
                    <td className="text-end fw-bold "><Rank result={result} /></td>
                </tr>
            </>    
        );

    }
    return (
        <table className="table table-sm table-bordered border">
            <thead>
                {rowHeader}
            </thead>
            <tbody>
                {rowResult}
            </tbody>
        </table>
    );

}

const Penalties = ({result}) => {

    const ptyWarmUp = result?.extendedResults?.find(er => er?.er_code === 'PTY_WARMUP' && er?.er_type === 'ER_EQ')?.er_value
    const ptyObstacle = result?.extendedResults?.find(er => er?.er_code === 'PTY_OBS' && er?.er_type === 'ER_EQ')?.er_value
    const ptyTime= result?.extendedResults?.find(er => er?.er_code === 'PTY_TIME' && er?.er_type === 'ER_EQ')?.er_value
    const ptyOthers= result?.extendedResults?.find(er => er?.er_code === 'PTY_OTH' && er?.er_type === 'ER_EQ')?.er_value

    return (
        <table className="w-50 table-borderless">
        <tbody>
            <tr>
                <td className="text-start"><Label data="HeaderWarmUp" />:</td>
                <td className="text-end">{ptyWarmUp}</td>
            </tr>
            <tr>
                <td className="text-start"><Label data="LabelObstacle" />:</td>
                <td className="text-end">{ptyObstacle}</td>
            </tr>
            <tr>
                <td className="text-start"><Label data="HeaderTime" />:</td>
                <td className="text-end">{ptyTime}</td>
            </tr>
            <tr>
                <td className="text-start"><Label data="HeaderOther" />:</td>
                <td className="text-end">{ptyOthers}</td>
            </tr>
        </tbody>
        </table>
    );

}

const Time = ({result}) => {
    const time = result?.extendedResults?.find(er => er?.er_code === 'TIME' && er?.er_type === 'ER_EQ')?.er_value;
    return <>{time}</>;

}

const Rank = ({result}) => {
    const rank = result?.resultRank && result?.resultRankEqual === 'Y' ? '='+result?.resultRank : result?.resultRank;
    return <>{rank}</>
}

export default PreviousCurrent;